// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".kt-switch.k5-switch[data-v-36d6451e]{font-size:1.5rem;display:flex;flex-direction:row-reverse;align-items:center;justify-content:flex-end}", ""]);
// Exports
module.exports = exports;
